import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";

const initialState = {} as IDeviceModel;

const deviceModelSlice = createSlice({
    name: "deviceModel",
    initialState,
    reducers: {
        setDeviceModel: (state, action: PayloadAction<IDeviceModel>) => {
            Object.assign(state, action.payload);
        },
        setDeviceModelList: (state, action) => {
            Object.assign(state, action.payload);
        },
    },
});

export const { setDeviceModel, setDeviceModelList } = deviceModelSlice.actions;
export default deviceModelSlice.reducer;

export const getDeviceModel = (state: RootState) => state.deviceModel;
